import { render, staticRenderFns } from "./editFontFamily.vue?vue&type=template&id=167f3aa6&scoped=true"
import script from "./editFontFamily.vue?vue&type=script&lang=js"
export * from "./editFontFamily.vue?vue&type=script&lang=js"
import style0 from "./editFontFamily.vue?vue&type=style&index=0&id=167f3aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167f3aa6",
  null
  
)

export default component.exports